import { render, staticRenderFns } from "./PopoverTagsCheckboxes.vue?vue&type=template&id=ad279bb6&scoped=true&"
import script from "./PopoverTagsCheckboxes.vue?vue&type=script&lang=js&"
export * from "./PopoverTagsCheckboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad279bb6",
  null
  
)

export default component.exports